import { EditorState } from 'prosemirror-state'

export const isEmptyDocWithTitle = (state: EditorState): boolean => {
  const doc = state.doc
  const isHeading = doc.firstChild?.type.name === 'heading' && doc.firstChild.childCount === 1
  const onlyHeading =  isHeading && doc.childCount === 1
  const emptyParagraph =  isHeading && doc.childCount === 2 && doc.lastChild?.childCount === 0

  return onlyHeading || emptyParagraph
}
